import { AfterViewInit, InjectionToken, OnDestroy, } from '@angular/core';
import { UiGridComponent, } from '@uipath/angular/components/ui-grid';
import isEqual from 'lodash-es/isEqual';
import { BehaviorSubject, combineLatest, of, Subject, } from 'rxjs';
import { map, shareReplay, startWith, } from 'rxjs/operators';
export var GRID_SERVICE = new InjectionToken('Grid-Data-Source');
export var GridPageState;
(function (GridPageState) {
    GridPageState[GridPageState["ready"] = 0] = "ready";
    GridPageState[GridPageState["pending"] = 1] = "pending";
})(GridPageState || (GridPageState = {}));
var GridComponent = /** @class */ (function () {
    function GridComponent() {
        var _this = this;
        this.pageSizes = [10, 25, 50];
        this.pageSize = 10;
        this.data$ = new Subject();
        this.total$ = new Subject();
        this.loading$ = new BehaviorSubject(true);
        this._refresh$ = new Subject();
        this._filters$ = new BehaviorSubject([]);
        this._initialGridFilters$ = new BehaviorSubject([]);
        this._state$ = new BehaviorSubject(GridPageState.ready);
        this._destroyed$ = new Subject();
        this._defaultPage = {
            length: NaN,
            pageIndex: 0,
            previousPageIndex: NaN,
            pageSize: this.pageSize,
        };
        this.getItemAtIndex = function (index) {
            return _this._grid.dataManager.get(index);
        };
    }
    Object.defineProperty(GridComponent.prototype, "_isInReadyState", {
        get: function () {
            return this._state$.getValue() === GridPageState.ready;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridComponent.prototype, "_isInPendingState", {
        get: function () {
            return this._state$.getValue() === GridPageState.pending;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridComponent.prototype, "_isLoading", {
        get: function () {
            return this.loading$.getValue();
        },
        enumerable: true,
        configurable: true
    });
    GridComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._pagination$ = this._grid.footer ?
            this._grid.footer.pageChange
                .pipe(startWith(this._defaultPage)) :
            of(this._defaultPage);
        this._search$ = this._grid.header ?
            this._grid.header.searchFilter
                .pipe(startWith([])) :
            of([]);
        this._aggregatedFilters$ = combineLatest([
            this._filters$,
            this._grid.filterManager.filter$.pipe(map(function (gridFilters, i) {
                if (i === 0) {
                    // on first emit store the initial input filters
                    _this._initialGridFilters$.next(gridFilters);
                }
                return gridFilters;
            })),
        ]).pipe(map(function (_a) {
            var pageFilters = _a[0], gridFilters = _a[1];
            return pageFilters.concat(gridFilters);
        }), shareReplay(1));
        this.hasCustomFilters$ = combineLatest([
            this._grid.filterManager.filter$,
            this._initialGridFilters$,
        ]).pipe(map(function (_a) {
            var currentFilters = _a[0], initialFilters = _a[1];
            return !isEqual(_this._sortByProperty(currentFilters), _this._sortByProperty(initialFilters));
        }));
    };
    GridComponent.prototype.ngOnDestroy = function () {
        this.loading$.complete();
        this._state$.complete();
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    GridComponent.prototype._sortByProperty = function (filters) {
        return filters.sort(function (a, b) { return (a.property > b.property) ? 1 : -1; });
    };
    return GridComponent;
}());
export { GridComponent };
